import { getApiClient } from "@src/api";
import { navbarBranchQueryKeys } from "@src/components/board/queries/fetch-ranklist";
import { whiteboardQueryKeys } from "@src/components/board/queries/query-keys";
import { graphql } from "@src/gql/gql";
import { queryClient } from "@src/query-client";
import { useMutation } from "@tanstack/react-query";
import type { Whiteboard } from "../schema";

const unpublishWhiteboardQuery = graphql(/* GraphQL */ `
	mutation unpublishWhiteboard($whiteboardId: String!, $sharingKey: String) {
		whiteboards {
			unpublish(whiteboardId: $whiteboardId, sharingKey: $sharingKey) {
				status
				name
				ownerId
				permissions {
					publishedLink {
						isReadonly
						key
					}
				}
			}
		}
	}
`);

/**
 * Unpublish a whiteboard, disabling its shareable link.
 *
 * @returns React Query mutation object
 */
export const useUnpublishWhiteboard = () => {
	const client = getApiClient();

	return useMutation({
		mutationFn: async (whiteboardId: string) => {
			const result = await client.mutate({
				mutation: unpublishWhiteboardQuery,
				variables: {
					whiteboardId,
				},
			});

			return result.data;
		},
		onSuccess: (_, whiteboardId) => {
			const queryData = queryClient.getQueryData<Whiteboard>(
				whiteboardQueryKeys.ofId(whiteboardId),
			);

			if (queryData) {
				queryClient.setQueryData(whiteboardQueryKeys.ofId(whiteboardId), {
					...queryData,
					publication: null,
					intake: {
						isOpen: false,
						key: null,
					},
				});
			}

			queryClient.invalidateQueries({
				queryKey: navbarBranchQueryKeys.all(),
			});
			queryClient.invalidateQueries({
				queryKey: whiteboardQueryKeys.ofId(whiteboardId),
			});
		},
	});
};
